module.exports = __webpack_public_path__ + "static/media/bg-b.a36327a7.jpg";